import { render, staticRenderFns } from "./ExchangeOrder.vue?vue&type=template&id=dd4ebad8&scoped=true"
import script from "./ExchangeOrder.vue?vue&type=script&lang=js"
export * from "./ExchangeOrder.vue?vue&type=script&lang=js"
import style0 from "./ExchangeOrder.vue?vue&type=style&index=0&id=dd4ebad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4ebad8",
  null
  
)

export default component.exports